import { bus_laixe } from "../../../models/response/bus/bus_laixe";

export enum eBusLaiXeActionTypeIds {
	LOAD_START = "BUS_LAIXE_LOAD_START",
	LOAD_SUCCESS = "BUS_LAIXE_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_LAIXE_LOAD_ERROR",

	SHOW_DETAIL = "BUS_LAIXE_SHOW_DETAIL",
	CLOSE_DETAIL = "BUS_LAIXE_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "BUS_LAIXE_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "BUS_LAIXE_SHOW_CONFIRM",
	CLOSE_CONFIRM = "BUS_LAIXE_CLOSE_CONFIRM",

	DELETE_START = "BUS_LAIXE_DELETE_START",
	DELETE_SUCCESS = "BUS_LAIXE_DELETE_SUCCESS",
	DELETE_ERROR = "BUS_LAIXE_DELETE_ERROR",

	SAVE_START = "BUS_LAIXE_SAVE_START",
	SAVE_SUCCESS = "BUS_LAIXE_SAVE_SUCCESS",
	SAVE_ERR = "BUS_LAIXE_SAVE_ERR"
}

export interface IBusLaiXeLoadStart {
	type: eBusLaiXeActionTypeIds.LOAD_START,
	payload: number
}
export interface IBusLaiXeLoadSuccess {
	type: eBusLaiXeActionTypeIds.LOAD_SUCCESS,
	payload: bus_laixe[]
}
export interface IBusLaiXeLoadErr {
	type: eBusLaiXeActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusLaiXeShowDetail {
	type: eBusLaiXeActionTypeIds.SHOW_DETAIL,
	payload?: bus_laixe
}
export interface IBusLaiXeCloseDetail {
	type: eBusLaiXeActionTypeIds.CLOSE_DETAIL
}
export interface IBusLaiXeChangeSelectedIds {
	type: eBusLaiXeActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IBusLaiXeShowConfirm {
	type: eBusLaiXeActionTypeIds.SHOW_CONFIRM
}
export interface IBusLaiXeCloseConfirm {
	type: eBusLaiXeActionTypeIds.CLOSE_CONFIRM
}
export interface IBusLaiXeDeleteStart {
	type: eBusLaiXeActionTypeIds.DELETE_START,
	payload: number
}
export interface IBusLaiXeDeleteSuccess {
	type: eBusLaiXeActionTypeIds.DELETE_SUCCESS
}
export interface IBusLaiXeDeleteErr {
	type: eBusLaiXeActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IBusLaiXeSaveStart {
	type: eBusLaiXeActionTypeIds.SAVE_START,
	payload: bus_laixe
}
export interface IBusLaiXeSaveSuccess {
	type: eBusLaiXeActionTypeIds.SAVE_SUCCESS
}
export interface IBusLaiXeSaveErr {
	type: eBusLaiXeActionTypeIds.SAVE_ERR,
	payload: string
}

export type IBusLaiXeActionTypes = IBusLaiXeLoadStart | IBusLaiXeLoadSuccess | IBusLaiXeLoadErr |
	IBusLaiXeShowDetail | IBusLaiXeCloseDetail |
	IBusLaiXeChangeSelectedIds |
	IBusLaiXeShowConfirm | IBusLaiXeCloseConfirm |
	IBusLaiXeDeleteStart | IBusLaiXeDeleteSuccess | IBusLaiXeDeleteErr |
	IBusLaiXeSaveStart | IBusLaiXeSaveSuccess | IBusLaiXeSaveErr
